// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

// project imports
import Search from './Search';
import Profile from './Profile';
import MobileSection from './MobileSection';

import { useEffect } from 'react';
import { useStore } from '../../../../stores/store';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const {outletStore} = useStore();
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  useEffect(()=>{
    outletStore.loadOutlets();
  },[outletStore])

  return (
    <>
      {!downLG && <Search />}
      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}
      {/* <IconButton
        component={Link}
        href="/dashboard"
        // target="_blank"
        disableRipple
        color="secondary"
        title="Download Free Version"
        sx={{ color: 'text.primary', bgcolor: 'grey.100' }}
      >
        {/* <GithubOutlined /> }
        <ShoppingCartOutlined />
      </IconButton> */}

      {/* <Notification /> */}
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}
